import { process as kendoProcess } from '@progress/kendo-data-query';

export default class ProcessDateString {
  static process(data, dataState) {
    if (!dataState.filter || !dataState.filter.filters) {
      return kendoProcess(data, dataState);
    }

    // Map filters
    const updatedFilters = dataState.filter.filters.map(f => {
      if (f.field && f.value && f.operator === 'contains') {
        return {
          ...f,
          // override operator to handle Date objects
          operator: (cellValue, filterValue) => {
            if (!cellValue) return false;

            // Convert date objects to US string, otherwise cast to string
            let cellStr;
            if (cellValue instanceof Date && !isNaN(cellValue.getTime())) {
              cellStr = cellValue.toLocaleDateString('en-US');
            } else {
              cellStr = String(cellValue);
            }

            return cellStr.includes(filterValue);
          }
        };
      }
      return f;
    });

    const newDataState = {
      ...dataState,
      filter: { ...dataState.filter, filters: updatedFilters }
    };

    return kendoProcess(data, newDataState);
  }
}
